<template>
  <main class="min-h-screen bg-gray-200">
    <header>
      <sqr-progress v-show="loading" />
      <sqr-error-banner :error="loadError" />
    </header>

    <div class="max-w-4xl md:px-4 lg:px-6 py-10">
      <subscription-panel :aid="aid" :subscription="subscription" />
      <!-- <invitation-panel /> -->
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

import SubscriptionPanel from '@/components/SubscriptionPanel';

export default {
  name: 'Subscription',
  components: { SubscriptionPanel },
  computed: {
    ...mapGetters('auth', ['uid', 'userEmail', 'displayName']),
    ...mapGetters('account', ['account']),
    subscription() {
      return this.account?.subscription;
    }
  },
  mounted() {
    this.$a().logEvent('subscription');
  }
};
</script>
